export var TransitionTypes = {
  'entering': 'entering',
  'exiting': 'exiting'
};